import { Redirect } from '#app/components/Redirect/index.js';
import { getRoute } from '@contra/routes';

export const Page = () => {
  return (
    <Redirect
      method="replace"
      to={getRoute('/client/home', {
        search: {
          modalName: 'JobCreationModal',
        },
      })}
    />
  );
};
